<template>
  <router-view class="bg-gradient" />
</template>

<style lang="scss">

</style>
